export default __webpack_public_path__ + "static/media/template10.63199d1d.png";